import { ControllingPdfColumn } from '@myapp/contract'
import { ScheduleStatus, DeviationStatus, ControllingReasonFilterValue } from '../../filters'

export const SCHEDULE_LABELS: Record<ScheduleStatus, string> = {
  WITHOUT_FOLLOW_UP: 'Ohne Folgetermin',
  WITH_FOLLOW_UPS: 'Mit Folgeterminen',
  RESCHEDULED_BY_OFFICE: 'Umnominiert (Büro)',
  RESCHEDULED_BY_TECHNICIAN: 'Umnominiert (HW)',
}

export const DEVIATION_LABELS: Record<DeviationStatus, string> = {
  ON_SCHEDULE: 'Planmäßig',
  OVER_TARGET: 'Über Soll',
  UNDER_TARGET: 'Unter Soll',
}

export const EXPORT_COLUMNS: Array<{ key: ControllingPdfColumn; label: string }> = [
  { key: 'workOrderId',        label: 'Auftrags-ID' },
  { key: 'scheduleStatus',     label: 'Terminstatus' },
  { key: 'reasons',            label: 'Grund' },
  { key: 'repairDate',         label: 'Reparaturtermin' },
  { key: 'building',           label: 'Gebäude' },
  { key: 'tenant',             label: 'Mieter' },
  { key: 'gewerkId',           label: 'Gewerk-Nr' },
  { key: 'trade',              label: 'Gewerk' },
  { key: 've',                 label: 'VE' },
  { key: 'technician',         label: 'Handwerker' },
  { key: 'plannedWorkHours',   label: 'Arbeit Soll (Std)' },
  { key: 'actualWorkHours',    label: 'Arbeit Ist (Std)' },
  { key: 'plannedTravelHours', label: 'Fahrt Soll (Std)' },
  { key: 'actualTravelHours',  label: 'Fahrt Ist (Std)' },
  { key: 'plannedTotalHours',  label: 'Gesamt Soll (Std)' },
  { key: 'actualTotalHours',   label: 'Gesamt Ist (Std)' },
  { key: 'deviation',          label: 'Abweichung (%)' },
  { key: 'deviationHours',     label: 'Abweichung (Std)' },
  { key: 'wertEuro',           label: 'Wert (€)' },
]

export const REASON_FILTER_LABELS: Record<ControllingReasonFilterValue, string> = {
  MIETER_NICHT_VOR_ORT: 'Mieter war nicht vor Ort',
  TERMIN_NICHT_EINGEHALTEN: 'Termin nicht eingehalten',
  WEITERER_GRUND: 'Weiterer Grund',
  MIT_ANDEREM_GEWERK: 'Mit anderem Gewerk',
  MATERIAL_BESTELLUNG: 'Material Bestellung',
  SICK_LEAVE: 'Krankheit',
  VACATION: 'Urlaub',
  TRAINING: 'Schulung',
  PERSONAL_LEAVE: 'Privatzeit',
}
